import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    reportsPage_settingEmail: 'Настройка почты',
    reportsPage_emailColumn:'Почта',
    reportsPage_deleteEmailModal:'Удаление',
    reportsPage_deleteEmailConfirmText:'Вы уверены, что хотите удалить почту?',
    reportsPage_deleteEmailBtn:'Удалить',
    reportsPage_actionsColumn:'Действие',
    reportsPage_addEmail:'Добавить',
    reportsPage_addEmailModal:'Добавить почту',
    reportsPage_emailLabel: "Email",
    reportsPage_cancelBtn: "Отмена",
    reportsPage_saveBtn: "Сохранить",
    reportsPage_addEmailError: "Ошибка при добавлении Email",
    reportsPage_emailRequired: "Пожалуйста, введите email",
    reportsPage_emailInvalid: "Введите корректный email",
    reportsPage_registryReport:'Реестр отчетов',
    reportsPage_registryCreatedDateColumn:'Дата и время формирования отчёта',
    reportsPage_registryReportPeriod:'Отчётный период',
    reportsPage_errorLoadEmailList:'Не удалось получить список адресов электронной почты',
    reportsPage_errorDeleteEmail:'Не удалось удалить электронную почту',
    reportsPage_errorAddEmail:'Не удалось добавить электронную почту',


    // REPORTS FINCENTER ACTS
    reportsPage_periodMonth:'Расчетный месяц',
    reportsPage_fincenterActNumber:'Номер акта',
    reportsPage_fincenterPaymentAmount:'Сумма оплаты',
    reportsPage_fincenterActCreatedDate:'Дата формирования',
    reportsPage_fincenterSuccessDownload:'Акт успешно экспортирован',
    reportsPage_fincenterErrorDownload:'Ошибка при загрузке акта',
    reportsPage_fincenterActPage:'Отчет по расчету сумм оказанных услуг',
    reportsPage_fincenterActPeriod:'Период',
    reportsPage_fincenterActGoBack:'Назад к списку',
    reportsPage_fincenterErrorGetActById:'Не удалось получить данные акта',
    reportsPage_fincenterLoadingAct:'Загрузка данных акта...',
    reportsPage_fincenterActNotFound:'Акт не найден.',
    reportsPage_fincenterLoadingReport:'Загрузка отчета...',
    reportsPage_fincenterDocumentNotAvailable:'Документ недоступен.',
    reportsPage_generateFincenterAct:'Сформировать отчет',
    reportsPage_fincenterSuccessGenerate:'Отчет успешно сформирован',
    reportsPage_errorGenerateFincenterAct:'Не удалось сформировать отчет',
    reportsPage_fincenterActionView:'Просмотр',
    reportsPage_fincenterActInfo: 'Формирование отчета доступно с 16 числа до конца текущего месяца и может быть выполнено только один раз. Перед формированием отчета необходимо убедиться, что все данные табелей проверены и корректны',
  },
  kk: {
    reportsPage_settingEmail: 'Поштаны баптау',
    reportsPage_emailColumn: 'Пошта',
    reportsPage_deleteEmailModal: 'Жою',
    reportsPage_deleteEmailConfirmText: 'Поштаны жоюға сенімдісіз бе?',
    reportsPage_deleteEmailBtn: 'Жою',
    reportsPage_actionsColumn: 'Әрекет',
    reportsPage_addEmail: 'Қосу',
    reportsPage_addEmailModal: 'Поштаны қосу',
    reportsPage_emailLabel: 'Email',
    reportsPage_cancelBtn: 'Бас тарту',
    reportsPage_saveBtn: 'Сақтау',
    reportsPage_addEmailError: 'Email қосу кезінде қате пайда болды',
    reportsPage_emailRequired: 'Поштаны енгізіңіз',
    reportsPage_emailInvalid: 'Дұрыс email енгізіңіз',
    reportsPage_registryReport: 'Есептер тізілімі',
    reportsPage_registryCreatedDateColumn: 'Есептің құрылу күні мен уақыты',
    reportsPage_registryReportPeriod: 'Есеп беру кезеңі',
    reportsPage_errorLoadEmailList: 'Пошталар тізімін алу мүмкін болмады',
    reportsPage_errorDeleteEmail: 'Поштаны жою мүмкін болмады',
    reportsPage_errorAddEmail: 'Поштаны қосу мүмкін болмады',


    // REPORTS FINCENTER ACTS
    reportsPage_periodMonth:'Есеп айы',
    reportsPage_fincenterActNumber:'Акт нөмірі',
    reportsPage_fincenterPaymentAmount:'Төлем сомасы',
    reportsPage_fincenterActCreatedDate:'Акт құрылу күні',
    reportsPage_fincenterSuccessDownload:'Акт сәтті экспортталды',
    reportsPage_fincenterErrorDownload:'Акты жүктеу кезінде қате пайда болды',
    reportsPage_fincenterActPage:'Көрсетілген қызмет соммаларын есептеу туралы есеп',
    reportsPage_fincenterActPeriod:'Период',
    reportsPage_fincenterActGoBack:'Тізімге қайту',
    reportsPage_fincenterErrorGetActById:'Акт туралы мәліметтерді алу мүмкін болмады',
    reportsPage_fincenterLoadingAct:'Акт мәліметтері жүктелуде...',
    reportsPage_fincenterActNotFound:'Акт табылмады.',
    reportsPage_fincenterLoadingReport:'Есеп жүктелуде...',
    reportsPage_fincenterDocumentNotAvailable:'Құжат қол жетімді емес.',
    reportsPage_generateFincenterAct:'Есепті қалыптастыру',
    reportsPage_fincenterSuccessGenerate:'Есеп сәтті қалыптастырылды',
    reportsPage_errorGenerateFincenterAct:'Есепті қалыптастыру мүмкін болмады',
    reportsPage_fincenterActionView:'Көру',
    reportsPage_fincenterActInfo: 'Есепті қалыптастыру ағымдағы айдың 16-сынан бастап айдың соңына дейін қолжетімді және тек бір рет орындалуы мүмкін. Есепті қалыптастырмас бұрын барлық табель деректерінің тексеріліп, дұрыс екеніне көз жеткізу қажет',

  }
});
